import { cn } from "@aircall/ds";
import { AiAssist } from "@aircall/react-icons";
import type { FeatureBannerProps } from "./FeatureBanner.decl";

const ALIGN_ITEMS_CLASS: Record<string, string> = {
  center: "items-center",
  "flex-start": "items-start",
  "flex-end": "items-end",
  baseline: "items-baseline",
  stretch: "items-stretch",
};

export function FeatureBanner({
  children,
  content,
  maxW,
  fluid,
  icon: IconComponent = AiAssist,
  direction = "horizontal",
  alignItems = "center",
  "data-test": dataTest = "feature-banner",
}: FeatureBannerProps) {
  const alignClass =
    (typeof alignItems === "string" && ALIGN_ITEMS_CLASS[alignItems]) ||
    "items-center";

  const maxWidth =
    typeof maxW === "string" || typeof maxW === "number" ? maxW : undefined;

  return (
    <div
      data-test={dataTest}
      style={{
        background: "linear-gradient(225deg, #f5fffb 0%, #c2ffec 100%)",
        maxWidth,
      }}
      className={cn(
        "flex justify-between gap-4 rounded-2xl border border-[#C2FFEC] px-6 py-4 text-[#004736]",
        direction === "vertical" ? "flex-col" : "flex-row",
        alignClass,
        fluid ? "w-full" : "w-auto"
      )}
    >
      <div className="flex items-center gap-4">
        <span className="shrink-0 text-[#004736] [&>svg]:size-6">
          <IconComponent />
        </span>
        <span className="text-sm font-semibold">{content}</span>
      </div>
      {children}
    </div>
  );
}
